/* MHH Oct 2026: type tabs + brand filter, chat routing (GHL widget first), quiz helpers */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- type tabs + brand tiles (one combined filter) ---------- */
  $$('[data-mx-filters]').forEach(function (root) {
    var target = document.getElementById(root.getAttribute('data-mx-filters'));
    if (!target) return;
    var track = $('[data-mx-track]', target);
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var tabs = $$('[data-mx-type]', root), tiles = $$('[data-mx-vendor]', root);
    var empty = $('[data-mx-empty]', target), emptyMsg = $('[data-mx-empty-msg]', target);
    var defMsg = emptyMsg ? emptyMsg.textContent : '';
    var count = $('[data-mx-count]', root);
    var st = { v: 'all', t: 'all' };
    function has(it, tag) { return (it.getAttribute('data-tags') || '').indexOf(' ' + tag + ' ') > -1; }
    function apply(scroll) {
      var n = 0;
      items.forEach(function (it) {
        var ok = (st.v === 'all' || it.getAttribute('data-vendor') === st.v) && (st.t === 'all' || has(it, st.t));
        it.hidden = !ok; if (ok) n++;
      });
      // brand tiles: only show brands that have products of the chosen type
      tiles.forEach(function (b) {
        var v = b.getAttribute('data-mx-vendor');
        if (v === 'all') return;
        b.hidden = st.t !== 'all' && !items.some(function (it) { return it.getAttribute('data-vendor') === v && has(it, st.t); });
      });
      if (count) count.textContent = items.filter(function (it) { return st.t === 'all' || has(it, st.t); }).length + ' products';
      if (empty) {
        empty.hidden = n > 0;
        if (emptyMsg) {
          var on = tabs.filter(function (t) { return t.getAttribute('data-mx-type') === st.t; })[0];
          emptyMsg.textContent = st.t !== 'all' && on ? on.textContent.trim() + ' is installed by quote. Tell us about your home and we\'ll send an upfront installed price, with no pressure.' : defMsg;
        }
      }
      if (track && scroll !== false) track.scrollTo({ left: 0 });
      target._mxUpd && target._mxUpd();
    }
    function setType(t, push) {
      st.t = t;
      tabs.forEach(function (x) { var on = x.getAttribute('data-mx-type') === t; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (st.v !== 'all') { var vt = tiles.filter(function (b) { return b.getAttribute('data-mx-vendor') === st.v; })[0]; if (vt && vt.hidden) setVendor('all'); }
      if (push) { try { var u = new URL(location.href); if (t === 'all') u.searchParams.delete('type'); else u.searchParams.set('type', t); history.replaceState(null, '', u); } catch (e) {} }
      apply();
    }
    function setVendor(v) {
      st.v = v;
      tiles.forEach(function (x) { var on = x.getAttribute('data-mx-vendor') === v; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { setType(t.getAttribute('data-mx-type'), true); }); });
    tiles.forEach(function (t) { t.addEventListener('click', function () { setVendor(t.getAttribute('data-mx-vendor')); apply(); }); });
    var q = null; try { q = new URL(location.href).searchParams.get('type'); } catch (e) {}
    if (q && tabs.some(function (t) { return t.getAttribute('data-mx-type') === q; })) setType(q, false); else apply(false);
  });

  /* ---------- chat: GHL chat widget first, then the theme's own chat ---------- */
  function openGhl() {
    try {
      var lc = window.leadConnector && window.leadConnector.chatWidget;
      if (lc && typeof lc.openWidget === 'function') { lc.openWidget(); return true; }
    } catch (e) {}
    return false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mx-chat]');
    if (!b) return;
    if (openGhl()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    // header/menu links: no chat dialog on this page → follow the link to the contact page
    if (b.tagName === 'A' && !document.getElementById('mxChat') && !window.tidioChatApi && !window.Tawk_API && !window.$crisp && !window.$chatway && !window.HubSpotConversations) {
      e.stopImmediatePropagation();
    }
  }, true);
  if (/[?&]chat=1/.test(location.search)) {
    window.addEventListener('load', function () {
      setTimeout(function () { var c = $('.mx-cm-card [data-mx-chat]'); if (openGhl()) return; c && c.click(); }, 600);
    });
  }
})();

/* ---------- Oct 16: product sticky bar, monthly estimate, reliable jump to the form ---------- */
(function () {
  'use strict';
  var mobile = function () { return window.matchMedia('(max-width: 980px)').matches; };
  // 1) Product pages: Call / Book bar only after the shopper scrolls past Add to cart
  var bar = document.querySelector('.mobile-cta.mcta-pdp');
  var atc = document.querySelector('.pdp-atc button[type="submit"], .pdp-atc [type="submit"]');
  if (bar) {
    if (!atc) { bar.classList.add('on'); document.body.classList.add('mcta-shown'); }
    else {
      var tick = false;
      var upd = function () { tick = false; var past = atc.getBoundingClientRect().bottom < 0; bar.classList.toggle('on', past); document.body.classList.toggle('mcta-shown', past); };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }
  }
  // 2) humm monthly figure follows the selected size
  var mo = document.querySelector('[data-monthly]'), pj = document.getElementById('productJson'), vin = document.querySelector('[data-variant-input]');
  if (mo && pj && vin) {
    var prod = null; try { prod = JSON.parse(pj.textContent); } catch (e) {}
    var sync = function () { if (!prod) return; var v = (prod.variants || []).filter(function (x) { return String(x.id) === String(vin.value); })[0]; if (v) mo.textContent = '$' + Math.ceil(v.price / 1200).toLocaleString('en-CA'); };
    document.addEventListener('click', function (e) { if (e.target.closest('[data-variant-pills] button')) setTimeout(sync, 30); });
    new MutationObserver(sync).observe(vin, { attributes: true, attributeFilter: ['value'] });
    vin.addEventListener('change', sync);
  }
  // 3) "#book" links land on the form itself on phones, and stay there while images load
  var targetFor = function (hash) {
    if (hash === '#book' && mobile()) return document.getElementById('book-form') || document.getElementById('book');
    if (hash === '#book' || hash === '#book-form' || hash === '#LocQuote') return document.getElementById(hash.slice(1));
    return null;
  };
  // Mobile "Book install" uses the form on this page when there is one
  var mb = document.querySelector('.mobile-cta .btn-primary');
  if (mb) { if (document.getElementById('book-form')) mb.setAttribute('href', '#book-form'); else if (document.getElementById('LocQuote')) mb.setAttribute('href', '#LocQuote'); }
  var userMoved = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { userMoved = true; }, { passive: true, once: true }); });
  var go = function (el, smooth) { if (el) el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); };
  var t0 = targetFor(location.hash);
  if (t0) {
    go(t0);
    [250, 700, 1400, 2400].forEach(function (ms) { setTimeout(function () { if (!userMoved) go(targetFor(location.hash)); }, ms); });
    window.addEventListener('load', function () { if (!userMoved) go(targetFor(location.hash)); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]'); if (!a) return;
    var href = a.getAttribute('href'), i = href.indexOf('#'); if (i < 0) return;
    var path = href.slice(0, i).split('?')[0], hash = href.slice(i);
    if (path && path !== location.pathname) return;
    var el = targetFor(hash); if (!el) return;
    e.preventDefault(); go(el, true);
    try { history.replaceState(null, '', hash); } catch (err) {}
  });
})();
